import { z } from "zod";
import { USER_ACTIVITY_STATUSES, phoneRegex } from "@miplatform/constants";

export const schema = z.object({
  firstName: z
    .string()
    .min(1, "First name is required.")
    .regex(
      /^[A-Za-zÀ-ÖØ-öø-ÿ' ]+$/,
      "First name should only contain letters, spaces, or apostrophes."
    ),
  lastName: z
    .string()
    .min(1, "Last name is required.")
    .max(20, "Last name should not exceed 20 characters.")
    .regex(/^[A-Za-z]+$/, "Last name should only contain letters."),
  displayName: z
    .string()
    .min(1, "Display name is required.")
    .max(20, "Display name should not exceed 20 characters."),
  userName: z.string().min(3, "User name is required."),
  language: z.string().optional(),
  email: z.string().email("Invalid email address."),
  primaryPhoneNumber: z
    .string()
    .regex(phoneRegex, "Phone number must be numeric and 10 digits")
    .optional()
    .or(z.literal("")),
  roleIds: z.array(z.string()).optional(),
  pin: z
    .string()
    .min(4, { message: "PIN must be at least 4 digits long" })
    .regex(/^\d+$/, { message: "PIN must contain only digits" })
    .optional(),
  title: z.string().optional(),
  timezone: z.string().optional(),
  departmentIds: z.array(z.string()).optional(),
  resourceId: z.string().optional(),
  status: z.enum(Object.values(USER_ACTIVITY_STATUSES)).optional(),
});
